import { Logo } from 'common/components/layout';

const Header = (props) => {
  const { clubMembership } = props;
  return (
    <>
      <div className="c7-checkout__header">
        <Logo />
      </div>
      <div className="c7-account-row c7-account-row--basic">
        <h2>{clubMembership.club.title}</h2>
      </div>
    </>
  );
};

export default Header;
